import { render, staticRenderFns } from "./modalCrearEmpacador.vue?vue&type=template&id=e768e48a&scoped=true&"
import script from "./modalCrearEmpacador.vue?vue&type=script&lang=js&"
export * from "./modalCrearEmpacador.vue?vue&type=script&lang=js&"
import style0 from "./modalCrearEmpacador.vue?vue&type=style&index=0&id=e768e48a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e768e48a",
  null
  
)

export default component.exports